export const iconfield = {
  iconColor: '{text.color}',
};
